function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../../../../components");
var _styles = require("../../../../../styles");
var _useLang = require("../useLang");
var _reactI18next = require("react-i18next");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["isWidthAuto"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var NextButton = exports.NextButton = (0, _react.memo)(function (_ref) {
  var isWidthAuto = _ref.isWidthAuto,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useSharedLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var buttonProps = {
    type: _components.ButtonType.brand,
    size: _components.ButtonSize.normal
  };
  if (bp.desktop) {
    buttonProps.size = _components.ButtonSize.large;
  }
  return (0, _jsxRuntime.jsx)(_components.Button, Object.assign({}, buttonProps, {
    label: t('onboardingShared:next'),
    containerStyle: [styles.buttonContainer, isWidthAuto && {
      width: 'auto'
    }],
    testID: "NextButton"
  }, props));
});